import {
  Grid,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';
import { LIGHT_GRAY } from 'commons/styles/colors';

class STOSuratPesananOOTPrekursorPrintTemplateStyle extends CommonComponentStyle {
  PageWrapper = styled.div`
    padding: 0 8mm 16mm 8mm;
    width: 210mm;
    height: 297mm;
    @media print {
      size: portrait;

      .pagebreak-after {
        page-break-after: always !important;
      }
    }
  `;

  PageHeader = styled(TableHead)`
    width: 210mm;
    margin-top: 8mm !important;
  `;

  RepeatingHeaderWrapper = styled.div`
    width: 210mm;
    margin-top: 8mm !important;
  `;

  PageBody = styled(TableBody)`
    margin-top: 16px !important;
    page-break-inside: auto;
  `;

  PageFooter = styled(TableFooter)<{ pageOffset?: number }>`
    position: absolute;
    width: 210mm;
    height: 30mm;
    bottom: 0;
    border-top: 2px solid black;

    &.last-page {
      margin-bottom: -${(props) => (props.pageOffset ? props.pageOffset * 100 : 0)}vh;
    }
  `;

  PageFooterText = styled.div`
    font-size: 12px;
    margin-top: 4mm;
    font-weight: 700;
  `;

  PageNumberText = styled.p`
    font-size: 12px;
    margin-top: 8mm;
  `;

  SuratPesananLabel = styled.div`
    font-weight: 700;
    text-align: center;
    font-size: 16px;
  `;

  HeaderCopeWrapper = styled(Grid)`
    margin-top: 8mm !important;
    text-align: center;
  `;

  STOSuratPesananCopeWrapper = styled(Grid)`
    margin-top: 8px;
    font-size: 12px;
  `;

  CompanyProfileWrapper = styled(Grid)`
    padding: 4px 8px 4px 16px;
    font-size: 12px;
  `;

  CompanyAddressText = styled.div`
    white-space: pre-line;
    line-height: 105%;
    margin: 2px 0;
  `;

  PrintInfoWrapper = styled(Grid)`
    font-size: 12px;
    font-style: italic;
    margin-top: 32px;
    margin-bottom: 8px !important;
  `;

  TableHeadStyle = styled(TableHead)`
    background-color: ${LIGHT_GRAY};
  `;

  TableHeaderCell = styled(TableCell)`
    font-weight: 700 !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
    border: 1px solid black;
  `;

  TableRowStyle = styled(TableRow)`
    height: 12mm !important;
  `;

  TableBodyCell = styled(TableCell)`
    line-height: 100% !important;
    padding: 8px !important;
    vertical-align: top !important;
    border: 1px solid black;
  `;

  PostTableInformationSectionWrapper = styled(Grid)`
    font-size: 12px;
  `;

  SignatureSectionWrapper = styled(Grid)`
    font-size: 12px;
    margin-top: 24px !important;
  `;
}

export default new STOSuratPesananOOTPrekursorPrintTemplateStyle();
